// format.ts - 표시용 숫자 포매터(순수). 도메인 값이 아니라 "보이는 문자열"만 만든다.
// 값이 없을 때는 0 이 아니라 EMPTY 로. 미입력과 0 을 화면에서 구분해야 한다.

// 빈 값 자리표시자. 디자인시스템 금지사항 2(em-dash U+2014 금지)에 따라
// 일반 하이픈이다. 화면에 보이는 문자열이므로 리터럴을 흩뿌리지 않고 여기
// 한 곳에서만 정의한다 - 두 종류의 대시가 화면에 섞이는 사고를 막는다.
export const EMPTY = "-";

export const fmt = (n: number | null | undefined): string =>
  n == null || Number.isNaN(n) ? EMPTY : Math.round(n).toLocaleString("ko-KR");

// 소수 n자리 고정(후행 0 유지). 예: fmtDec(242, 2) → "242.00".
export const fmtDec = (n: number | null | undefined, digits = 2): string =>
  n != null && Number.isFinite(n)
    ? n.toLocaleString("ko-KR", { minimumFractionDigits: digits, maximumFractionDigits: digits })
    : EMPTY;

// 큰 수 압축 표기 - 조/억/만 단위. 대시보드 카드처럼 폭이 좁은 곳에서 쓴다.
export const fmtComp = (n: number | null | undefined): string => {
  if (n == null || Number.isNaN(n)) return EMPTY;
  const a = Math.abs(n);
  if (a >= 1e12) return `${(n / 1e12).toFixed(2)}조`;
  if (a >= 1e8) return `${(n / 1e8).toFixed(1)}억`;
  if (a >= 1e4) return `${Math.round(n / 1e4).toLocaleString("ko-KR")}만`;
  return fmt(n);
};

export const pct = (n: number | null | undefined, d = 1): string =>
  n == null || Number.isNaN(n) ? EMPTY : `${n.toFixed(d)}%`;
